// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearGroup = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.71338 10.1803L10.0734 5.82031',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.98663 6.91343C6.43951 6.91343 6.80662 6.54632 6.80662 6.09344C6.80662 5.64057 6.43951 5.27344 5.98663 5.27344C5.53376 5.27344 5.16663 5.64057 5.16663 6.09344C5.16663 6.54632 5.53376 6.91343 5.98663 6.91343Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.3467 10.7269C10.7996 10.7269 11.1667 10.3598 11.1667 9.9069C11.1667 9.45403 10.7996 9.08691 10.3467 9.08691C9.89385 9.08691 9.52673 9.45403 9.52673 9.9069C9.52673 10.3598 9.89385 10.7269 10.3467 10.7269Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.00004 14.6663C11.6819 14.6663 14.6667 11.6816 14.6667 7.99967C14.6667 4.31778 11.6819 1.33301 8.00004 1.33301C4.31814 1.33301 1.33337 4.31778 1.33337 7.99967C1.33337 11.6816 4.31814 14.6663 8.00004 14.6663Z',
      stroke: 'currentColor',
      strokeWidth: '1.5',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearGroup };
